import { ReactNode } from "react";

interface InvisibleProps {
  className?: string;
  children?: ReactNode;
}

export function Invisible({
  className,
  children,
}: InvisibleProps): JSX.Element {
  return (
    <div className={`invisible ${className}`} aria-hidden>
      {children}
    </div>
  );
}
